import CustomRadioButton from "../../components/buttons/CustomRadioButton";
import DropdownButtonForSearch from "../../components/Dropdowns/DropdownButtonForSearch";
import InputField from "../../components/inputfields/InputField";
import InputLabel from "../../components/inputfields/InputLabel";
import S3ImageUpload from "../../components/S3uploads/S3ImageUpload";

interface PaidMobileMoneyProps {
  formData: {
    [key: string]: any;
  };
  handleInputChange: (field: string, value: string) => void;
  notEnglish: boolean;
  errors: {
    [key: string]: string;
  };
}

export default function PaidMobileMoney({
  formData,
  handleInputChange,
  notEnglish,
  errors,
}: PaidMobileMoneyProps) {
  return (
    <div className="w-full flex pb-4 ">
      <div className="bg-background_blue w-full rounded-lg p-4">
        <InputLabel
          labelName={"Receiver Payment Source"}
          id={"choose_bank"}
          required={true}
        />
        <CustomRadioButton
          options={[
            { id: "Bank", label: "Bank" },
            { id: "Cash", label: "Cash" },
            { id: "Card", label: "Card" },
            { id: "Mobile Money", label: "Mobile Money" },
          ]}
          selected={formData?.receiver_payment_source}
          onChange={(value: string) =>
            handleInputChange("receiver_payment_source", value)
          }
          gapClassName={"gap-x-[40px]"}
          padding="py-1"
          dir={notEnglish ? "rtl" : "ltr"}
        />
        <div className="pt-4 flex gap-10">
          <DropdownButtonForSearch
            labelName={"Choose Platform"}
            id="choose_platform"
            placeholder="platform"
            required={true}
            noSearch={true}
            errorMessage={errors?.choose_platform}
            onChange={handleInputChange}
            tabIndex={1}
            options={["M-Paisa", "M-Hawala", "My Money", "MoMo", "Hesab Pay"]}
            selectedValue={formData?.choose_platform}
          />
          {formData?.choose_platform && (
            <InputField
              inputItem={{
                labelName:
                  formData?.choose_platform === "Hesab Pay"
                    ? "Hesab Pay Account Number"
                    : "Associated Phone Number",
                id:
                  formData?.choose_platform === "Hesab Pay"
                    ? "hesabpay_account_number"
                    : "associated_phone_number",
              }}
              errorMessage={
                formData?.choose_platform === "Hesab Pay"
                  ? errors.hesabpay_account_number
                  : errors.associated_phone_number
              }
              onChange={(e) =>
                handleInputChange(
                  formData?.choose_platform === "Hesab Pay"
                    ? "hesabpay_account_number"
                    : "associated_phone_number",
                  e.target.value
                )
              }
              value={
                formData?.choose_platform === "Hesab Pay"
                  ? formData?.hesabpay_account_number
                  : formData?.associated_phone_number
              }
              tabIndex={0}
              required={true}
              // className="w-[400px]"
            />
          )}
        </div>
        <S3ImageUpload
          heading=""
          label="Mobile Money Transfer Receipt"
          disabled={false}
          upload_id={"transaction_receipt"}
          UploadPath={"uploads/mobile_money_receipt"}
          handleUpload={handleInputChange}
          uploadedFile={formData.transaction_receipt || ""}
          errorMessage={errors?.transaction_receipt}
          required={true}
          paddingTop={(errors?.associated_phone_number || errors?.hesabpay_account_number) ? "pt-0" : "pt-4"}
        />
      </div>
    </div>
  );
}
